import _ from 'lodash'

export default {
	namespaced: true,
	state: {
        sources: [],
        stages: {
            attention: {
                direct: 0, 
                search: 0,
                social: 0,
                display: 0,
                referral: 0,
                message: 0,
                other: 0
            }, 
            interest: {
                direct: 0, 
                search: 0,
                social: 0,
                display: 0,
                referral: 0,
                message: 0,
                other: 0
            }, 
            desire: {
                direct: 0, 
                search: 0,
                social: 0,
                display: 0,
                referral: 0,
                message: 0,
                other: 0
            }, 
            action: {
                direct: 0, 
                search: 0,
                social: 0,
                display: 0,
                referral: 0,
                message: 0,
                other: 0
            }
        }
    },
    getters: {
        values: state => {
            let values = []
            if (state.sources.length) {
                for (let stage in state.stages) {
                    let stageValues = []
                    for(let key in state.stages[stage]) {
                        if (state.sources.indexOf(key) != -1) {
                            stageValues.push(state.stages[stage][key])
                        }
                    }
                    values.push(stageValues)
                }
            }
            return values
        }
    },
    mutations: {
        updateSources(state) {
            // let sources = _.uniq(events.map(event => event.source.category))
            // state.sources = []
            // for (let key in state.stages.attention) {
            //     if (sources.indexOf(key) != -1) state.sources.push(key)
            // }
            state.sources = _.keys(state.stages.attention)
        },
        updateAttention(state, events) {
            for(let key in state.stages.attention) {
                state.stages.attention[key] = 0
            }
            for (let event of events) {
                state.stages.attention[event.source.category]++
            }
        },
        updateInterest(state, events) {
            for(let key in state.stages.interest) {
                state.stages.interest[key] = 0
            }
            // console.log(events)
            let firstSession = 1
            for (let event of events) {
                if (event.action.application == 'analytics') {
                    firstSession = event.session
                    break
                }
            }
            let hasInterest = false
            for (let event of events) {
                if (event.session > firstSession && event.action.application == 'analytics') {
                    state.stages.interest[event.source.category]++
                    hasInterest = true
                }
                if (['mail.send', 'mail.apply', 'voip.ring', 'shortener.redirect', 'sms.send'].indexOf(event.action.type) != -1) {
                    state.stages.interest[event.source.category]++
                    hasInterest = true
                }
            }
            if (hasInterest && window.dataLayer) {
                window.dataLayer.push({ category: 'whitebox', action: 'aida', label:'interest' })
            }
        },
        updateDesire(state, events) {
            for(let key in state.stages.desire) {
                state.stages.desire[key] = 0
            }
            let hasDesire = false
            for (let event of events) {
                if (['mail.send', 'mail.apply', 'voip.ring', 'shortener.redirect', 'sms.send'].indexOf(event.action.type) != -1) {
                    state.stages.desire[event.source.category]++
                    hasDesire = true
                }
            }
            if (hasDesire && window.dataLayer) {
                window.dataLayer.push({ category: 'whitebox', action: 'aida', label:'desire' })
            }
        },
        updateAction(state, events) {
            for(let key in state.stages.action) {
                state.stages.action[key] = 0
            }
            let hasAction = false
            for (let event of events) {
                if (event.action.application == 'data' || 
                    event.details && event.details.context == 'demo-meetings') {
                    hasAction = true
                    state.stages.action[event.source.category]++
                }
            }
            if (hasAction && window.dataLayer) {
                window.dataLayer.push({ category: 'whitebox', action: 'aida', label:'action' })
            }

        }
    },
    actions: {
        funnel({commit}, events) {
            commit('updateSources', events)
            commit('updateAttention', events)
            commit('updateInterest', events)
            commit('updateDesire', events)
            commit('updateAction', events)
		},
    }
}